import BackButton from '../../../../components/ui-components/BackButton'
import { getTopPadding } from '../../../../utils/sessionStorage'

type WithdrawalsPageHeaderProps = {
  onBack: () => void
}

export function WithdrawalsPageHeader({ onBack }: WithdrawalsPageHeaderProps) {
  return (
    <header
      style={{ paddingTop: `calc(${getTopPadding()}px + 8px)` }}
      className="flex items-center relative w-full pb-4 pl-[19px] pr-5 bg-white shrink-0"
    >
      <div className="flex shrink-0">
        <BackButton size={24} onClick={onBack} />
      </div>
      <div className="flex-1 flex pl-4 pr-8">
        <h1 className="text-[16px] font-[500] text-[#232323]">Withdrawals</h1>
      </div>
    </header>
  )
}
